<template>
  <div style="height:100vh;">
    <div v-wechat-title="$route.meta.title=docTitle"></div>
    <div class="top" v-if="actData">
      <liveTop :compMsg="actData" v-if="actData.company"></liveTop>
      <div class="live">

        <!-- 未到开播时间 -->
        <template v-if="!isLiveTime">
          <van-swipe class="my-swipe" indicator-color="white" :autoplay="isAutoplay" @change="swiperChange">
            <van-swipe-item v-if="videos && videos.url">
              <videoPlayer ref="videoPlays" @onPlayerPlay="onVideoPlay" @onPlayerPause="onVideoPause" :url="videos.url" :cover="videos.cover"></videoPlayer>
            </van-swipe-item>
            <van-swipe-item v-for="(item,index) in banner" :key="index">
              <img :src="item" style="width: 100%;height: 100%">
            </van-swipe-item>
          </van-swipe>
        </template>
        <!-- 已到开播时间 -->

        <template v-else>
          <!-- 需要密码或支付 -->
          <div class="live-layer" :style="{'background-image':actData.liveBackgroundUrl ? 'url('+actData.liveBackgroundUrl+oTopicBanner+')' : 'url(https://img.zhanshangxiu.com/showonline/file/202009/5834de2fce5d4505981eb13e80521b8b.png)'}" @click="payTouch" v-if="isViewLive && isViewLive.code != 1">
            <div class="live-layer-img">
              <img src="@/assets/img/live/video-icon.png">
            </div>
          </div>
          <!-- 播流 -->
          <template v-else>
            <!-- 直播未开始 -->
            <liveIng v-if="liveStatus === 0"></liveIng>

            <!-- 直播（结束） -->
            <!-- <liveEnd v-if="liveStatus === 3"></liveEnd> -->

            <!-- 主播出走 -->
            <liveAway v-if="liveStatus === 2"></liveAway>

            <!-- 直播中 -->
            <liveVideo v-if="liveStatus === 1 && liveUrl && !isBlack" :url="liveUrl" :cover="option.cover" :liveStatus="liveStatus" :showBg="showBg"></liveVideo>

            <div class="live-layer" v-else :style="{'background-image':actData.liveBackgroundUrl ? 'url('+actData.liveBackgroundUrl+oTopicBanner+')' : 'url(https://img.zhanshangxiu.com/showonline/file/202009/5834de2fce5d4505981eb13e80521b8b.png)'}"></div>
          </template>
        </template>
      </div>
      <div class="list">
        <div class="list-title">
          <span class="list-title-txt">{{(actData.isExhibitionActivity?actData.titleEn: actData.title)||'' }}</span>
          <span class="my-brand dot" v-if="actData.liveStateIndex === 1">
            Live
          </span>
          <span class="list-title-txt2">
            <img src="@assets/img/new/icon-zs.png">
            <!-- <img src="@assets/img/new/icon-zs2.png"> -->
            {{this.$service.getCount(actData.likeCount)}}
          </span>
        </div>
        <!-- 主办时间 -->
        <div class="list-main" v-if="!actData.exhibitorId">{{actData.startTime | moment('YYYY/MM/DD HH:mm')}}{{actData.endTime | moment('~ MM/DD HH:mm')}}</div>
        <!-- 展商活动时间 -->
        <div class="list-main" v-else>{{actData.startTime | moment('YYYY/MM/DD HH:mm')}}~{{actData.endTime | moment('~ MM/DD HH:mm')}}</div>
      </div>
    </div>

    <div class='tab-nav'>
      <span v-for="(item,index) in typeList" :key="index" @click="typeIndex = index" :class="typeIndex == index ? 'typeActive': ''">{{item}}</span>
    </div>

    <div class="content-bot">
      <liveDate v-if="typeIndex == 0" :introduction="introduction" :actData="actData" :isLive="true"></liveDate>

      <liveOnline v-if="typeIndex === 1" :isLive="true" style="height:100%"></liveOnline>

      <!-- <liveFollow v-if="typeIndex == 1" 
        :islike="isLike" 
        :userCount="actData.userCount" 
        :likeCount="actData.likeCount"
        @addlike="sendHandle"
        ref="follow"
        ></liveFollow> -->
    </div>

    <talk @sendHandle="sendHandle" @watchliveSend="send" :type="'nolive'" :islike="isLike" :isLove="isFollow"></talk>
    <!-- <actfooter :isLike="isLike" :isFollow="isFollow" @sendHandle="sendHandle" :actData="actData" :type="'live'" :exhibitionId='exhibitionId' :exhibitorId='exhibitorId'></actfooter> -->

    <!-- 预约洽谈 -->
    <order ref="order"></order>
    <liveShare ref="liveShare"></liveShare>

  </div>
</template>

<script>
import { Dialog } from "vant";
// import liveModule from "./components/live-module";
// import liveLangChoice from "./components/live-lang-choice";
// import liveContact from "./components/live-contact";
import liveGift from "./components/live-gift";
// import liveGiftInfo from "./components/live-gift-info";
import livePro from "./components/ex-live-pro";
import talk from "./components/talk";
import liveTool from "./components/live-tool";
import liveDate from "./components/live-date";
// import liveHot from "./components/live-hot";
import liveOnline from "./components/live-online";
// import livePic from "./components/live-pic";
// import liveTalk from "./components/live-talk";
import liveAct from "./components/live-act";
import liveTop from "./components/live-top";
import helpMoney from "@/components/help-money";
import liveShare from "@/components/live-share/index";
import liveVideo from "./components/live-video";
import livePay from "./components/live-pay";
import liveSubtitle from "./components/live-subtitle";
import hot from "./components/goHot";
import liveIng from "./components/live-ing";
import liveEnd from "./components/live-end";
import liveAway from "./components/live-away";
import videoPlayer from "../exhibition-invitation/components/videoPlayer";
import liveFollow from "./components/live-follow";
// import actfooter from "./components/footer";
import order from "@components/order-model.vue"; // 预约洽谈
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import gql from "graphql-tag";
import * as signalR from "@microsoft/signalr";

export default {
  name: "activity",
  data () {
    return {
      showLang: false,
      showGift: false,
      curIndex: 0,
      actData: "",
      isLike: false, // 点赞
      isFollow: false, // 围观
      regMsg: {}, // 开启报名的信息
      banner: [],
      timeoutflag: null,
      handCount: 0, // 鼓掌的次数
      isShowSubTitle: false,
      // 直播的数据
      liveStatus: 1, // 主播的直播状态  0：未开始 1：直播中 2：直播结束 3：直播断开
      isBlack: false, //是否被拉黑
      showBg: true,
      isSafari: false,
      hub: null,
      liveUrl: "",
      isViewLive: null, // 是否可以访问
      isShowPay: false,
      langType: "zh", //字慕语言type
      showSubtitle: "",
      docTitle: "Activity",
      viewerList: [],
      viewerCount: 0,
      queryLiveViewer: "",
      isLiveTime: false, // 是否为直播的当天日期
      videos: null,
      autoPlayVal: 3000,
      isAutoplay: 3000, //是否自动播放
      shareV: {
        content: "",
        poster: "",
      },
      typeList: ["Introduction", "Visitors"],
      typeIndex: 0,
      exhibitorId: "",
      introduction: [],
    };
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userInfo: "getUserInfo",
      api: "getApi",
      viewer: "getViewer",
      viewerId: "getViewerId",
      langOpt: "getLangOpt",
      exhibitionConfig: "getExhibitionConfig",
    }),
    ...mapState({
      oTopicBanner: "oTopicBanner",
    }),
    option () {
      return {
        id: "player-con",
        height: "100%",
        width: "100%",
        useH5Prism: true,
        useFlashPrism: false,
        aliplayerSdkPath:
          "http://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js",
        source: this.liveUrl,
        isLive: true,
        cover:
          this.actData.liveBackgroundUrl ||
          "https://img.zhanshangxiu.com/showonline/file/202009/5834de2fce5d4505981eb13e80521b8b.png",
        rePlay: true,
        playsinline: true,
        preload: true,
        language: "zh-cn",
        controlBarVisibility: "always",
        //prismplayer 2.0.1版本支持的属性，主要用户实现在android 微信上的同层播放
        x5_type: "h5-page", //通过 video 属性 “x5-video-player-type” 声明启用同层H5播放器，支持的值：h5 https://x5.tencent.com/tbs/guide/video.html
        x5_fullscreen: true, //通过 video 属性 “x5-video-player-fullscreen” 声明视频播放时是否进入到 TBS 的全屏模式，支持的值：true
      };
    },
    query () {
      return this.$router.history.current.query;
    },
    roomid () {
      return this.query.actId;
    },
    ActDetailsGql () {
      // 查询活动详情
      return gql`
        query activity($id: Guid!) {
          activity(id: $id) {
            anonymousView
            acvitityType
            banners
            introduction
            introductionEn
            company {
              name
              nameEn
              id
              logo
            }
            endTime
            exhibitor {
              id
              boothHall
              boothInfo
            }
            exhibitionId
            exhibitorId
            externalLink
            enabledOtherPull
            otherPullUrls
            followCount
            id
            startTime
            stateIndex
            title
            titleEn
            userCount
            likeCount
            videos
            viewCount
            regStartAt
            regEndAt
            regFee
            regMaximum
            liveStartTime
            liveEndTime
            liveStateIndex
            liveViewType
            liveBanners
            liveViewPassword
            livePaymentAmount
            liveBackgroundUrl
            liveEnabledSubtitles #启用字幕
            liveEnabledTranslate #启用同声翻译
            liveTranslateLangs #启用语言，多个按|分隔
            showLiveImage
            showPopularize
            showSchedule
            showTheme
            enabledGift
            enabledBuyingTicket
            isExhibitionActivity #是否为主题活动
          }
        }
      `;
    },
    online () {
      // 在线观众
      return gql`
        query queryLiveViewer($query: QueryInput!) {
          queryLiveViewer(query: $query) {
            hasNextPage
            hasPreviousPage
            items {
              helperMoney
              likeCount
              roomId
              userId
              userInfo
            }
            pageIndex
            pageSize
            totalCount
            totalPages
          }
        }
      `;
    },
    isRegOk () {
      return this.userInfo && this.userInfo.inMember && this.userInfo.inMember.userRole && this.userInfo.inMember.userRole != "VISITOR" && this.userInfo.inMember.userRole != "Visitor";
    },
    hasUserInfo () {
      return this.userInfo && this.userInfo.userId ? true : false;
    },
  },
  created () {
    document.title = "直播活动";
    this.init();
    this.$Myapollo.addExhibitionView();
  },
  components: {
    // liveModule,
    // liveLangChoice,
    // liveContact,
    liveGift,
    // liveGiftInfo,
    livePro,
    liveTool,
    liveDate,
    liveOnline,
    // liveHot,
    // livePic,
    // liveTalk,
    liveAct,
    talk,
    liveTop,
    liveShare,
    helpMoney,
    liveVideo,
    livePay,
    liveSubtitle,
    hot,
    liveIng,
    liveEnd,
    liveAway,
    videoPlayer,
    liveFollow,
    // actfooter,
    order,
  },
  methods: {
    ...mapActions({
      addActFollower: "act/addActFollower",
      addActZan: "act/addActZan",
      delActZan: "act/delActZan",
      addActLove: "act/addActLove",
      delActLove: "act/delActLove",
      LinkExInvitation: "linkTo/LinkExInvitation",
      addViewLikeIp: "addViewLikeIp",
      addViewLikeIpByCountry: "addViewLikeIpByCountry",
      shareToWechat: "wxShare/shareToWechat",
      getLiveUrl: "live/getLiveUrl",
      LinkHotPub: "linkTo/LinkHotPub",
      getRoomByLang: "live/getRoomByLang",
      LinkToActReg: "linkTo/LinkToActReg",
      LinkToActBuy: "linkTo/LinkToActBuy",
      LinkToError: "linkTo/LinkToError",
      getSettingShare: "wxShare/getSettingShare", //分享配置展会
      generateShareTemplate: "wxShare/generateShareTemplate", //关键字替换
      LinkFooter: "linkTo/LinkFooter",
      graphqlPostByZXS: "en/graphqlPostByZXS",
      LinkToReg: 'linkTo/LinkToReg',
    }),
    ...mapMutations({
      setLangOpt: "setLangOpt",
    }),
    async init () {
      // let body = {
      //     "exhibitionId": this.exhibitionId,
      //     "activityId": this.query.actId,
      //     "userId": this.userInfo.userId,
      // }
      // this.addActFollower(body);
      let body = {
        targetType: "activity",
        targetId: this.query.actId,
        actionType: "view",
      };
      if (this.userInfo && this.userInfo.country) {
        body.country = this.userInfo.country;
        this.addViewLikeIpByCountry(body);
      } else {
        this.addViewLikeIp(body);
      }
      this.getActDetails();
      this.getUserInit();
      this.checkForm(); // 分享记录数据添加
      this.getHub();
      if (localStorage.getItem("relepase")) {
        localStorage.setItem("relepase", "");
      }
      if (localStorage.getItem("Upimg")) {
        localStorage.setItem("Upimg", "");
      }
      if (localStorage.getItem("content")) {
        localStorage.setItem("content", "");
      }
      console.log(this.actData.exhibitorId, "actData.exhibitorId");
    },

    getUserInit () {
      if (!this.userInfo) return;
      this.getIslike();
      this.getIsFollow();
    },
    async getIslike () {
      let query = `
            query($activityId: Guid!,$userId: String!){
              activityLikeQuery{
                isLike(activityId: $activityId,userId: $userId)
              }
            }`;
      let opt = {
        query: query,
        variables: {
          activityId: this.query.actId,
          userId: this.userInfo.userId,
        },
      };
      let res = await this.graphqlPostByZXS(opt);
      if (res.data.activityLikeQuery) {
        this.isLike = res.data.activityLikeQuery.isLike;
      }
    },
    async getIsFollow () {
      let query = `
            query($activityId: Guid!,$userId: String!){
              activityFollowQuery{
                isFollow(activityId: $activityId,userId: $userId)
              }
            }`;
      let opt = {
        query: query,
        variables: {
          activityId: this.query.actId,
          userId: this.userInfo.userId,
        },
      };
      let res = await this.graphqlPostByZXS(opt);
      console.log(res.data.activityFollowQuery, "这个是关注的结果");
      if (res.data.activityFollowQuery) {
        this.isFollow = res.data.activityFollowQuery.isFollow;
      }
    },

    // 需要直播或密码
    payTouch () {
      this.isShowPay = true;
    },
    lookOk (type) {
      this.isShowPay = false;
      if (type != 1) {
        this.checkLiveView();
      }
      this.isViewLive.code = 1;
    },

    // 直播
    //用户发送弹幕
    send (text) {
      //  已经进入，得到直播间观众信息
      if (!this.hub) {
        this.$toast.fail("连接失败");
        this.reContact();
        return;
      }
      this.text = text;
      // console.log(this.hub,this.viewer,'发送时');
      if (this.viewer && this.viewerId) {
        var comment = {};
        comment.roomId = this.roomid;
        comment.userId = this.viewer.UserId;
        comment.userInfo = this.viewer.UserInfo;
        comment.viewerId = this.viewerId;
        comment.content = this.text;
        this.hub.invoke("ViewerComment", this.roomid, comment);
      } else {
        //未进入，先进入直播
        console.log("未发送，进入直播");
        this.viewerInit();
      }
    },
    //事件监听
    getLoadMethod () {
      const that = this;
      // 主播进入
      this.hub.on("AnchorEntryNotice", function (msg) {
        that.liveStatus = 1;
        console.log(msg, "主播进入");
      });
      // 主播离开
      this.hub.on("AnchorLeaveNotice", function (msg) {
        that.liveStatus = 3;
        that.showBg = true;
        console.log(msg, "主播离开");
      });
      // 主播结束直播
      this.hub.on("AnchorEndLiveNotice", function (msg) {
        that.liveStatus = 2;
        that.showBg = true;
        console.log(msg, "主播结束直播");
      });
      //拒绝开播
      this.hub.on("RefuseAnchorBeginLiveNotice", (state) => {
        switch (state) {
          case -1:
            this.$toast.fail("直播审核未通过");
            break;
          case 0:
            this.$toast.fail("直播待审核");
            break;
          case 1:
            this.$toast.fail("直播已结束");
            break;
          case 2:
            this.$toast.fail("直播已取消");
            break;
          case 3:
            this.$toast.fail("直播已下架");
            break;
          default:
            this.$toast.fail("直播出现异常");
            break;
        }
      });
      // 通知观众直播已开启
      this.hub.on("AnchorBeginLiveNotice", (res) => {
        this.liveStatus = 1;
        if (res && res.length === 3) {
          this.liveStatus = 1;
          this.showBg = false;
          if (this.actData.enabledOtherPull) {
            this.liveUrl = this.actData.otherPullUrls;
          } else {
            this.liveUrl = res[1]; // 直播地址
          }

          if (this.$refs.player) {
            this.$refs.player.play();
          }
          console.log("this.liveStatus: ", res);
          console.log("this.liveUrl: ", res);
        } else {
          this.showBg = true;
        }
      });
      //观众进入响应通知
      this.hub.on("ViewerEntryResponseNotice", (msg) => {
        console.log("观众进入响应通知", msg, "msg");
        if (msg.Data.viewer) {
          this.$store.commit("setViewer", msg.Data.viewer);
          this.$store.commit("setViewerId", msg.Data.viewer.Id);
          if (msg.Data.viewer.IsBlack) {
            this.$toast.fail("您已被拉黑");
            this.isBlack = true;
          }
          if (this.text) {
            this.send(this.text);
          }
        }
        // 正在直播
        if (msg && msg.Code === 1) {
          that.showBg = false;
          that.liveUrl = msg.Data.pulls[2]; // 直播地址
          that.showBg = true;
        }
        that.liveStatus = msg.Code;
        console.log(that.liveStatus, "直播状态");
        // that.liveStatus = 3;
        // 直播状态码（LiveCode）：0：未播、1：直播中、2：暂停中、3：已结束、4：已被下架、5：取消、6：未审核通过、7：审核中、8：审核通过
      });
      // 观众进入通知
      this.hub.on("ViewerEntryNotice", (res, onlineCount) => {
        let userinfo = res.UserInfo ? JSON.parse(res.UserInfo) : "";
        let model = {
          id: userinfo.id,
          isEntry: true,
          name: userinfo.nickName || userinfo.name,
          content: "",
        };
        this.$refs["barrage"].viewerEntry(model);
        console.log(res, "观众进入通知");
      });
      // 观众离开通知
      this.hub.on("ViewerLeaveNotice", (msg) => {
        console.log(msg, "观众离开通知");
      });
      // 留言删除通知（留言删除）
      this.hub.on("DeleteLiveCommentNotice", (commentid) => {
        this.$refs["barrage"].delBarrage(commentid);
      });
      // 观众留言通知（留言接收）
      this.hub.on("ViewerCommentNotice", (comment) => {
        let viewerName = "游客";
        if (comment.UserInfo) {
          viewerName =
            JSON.parse(comment.UserInfo).nickName ||
            JSON.parse(comment.UserInfo).name;
        }
        let model = {
          id: comment.Id,
          isEntry: false,
          name: viewerName,
          text: comment.Content,
        };
        console.log(model, "观众留言通知");
        this.$refs["barrage"].dataPush(model);
      });
      // 观众留言响应通知
      this.hub.on("ViewerCommentResponseNotice", (res) => {
        console.log("发送留言， 响应", res);
        //已授权
        if (!res.Result) {
          switch (this.liveStatus) {
            case 0:
              this.$toast.fail(res.Message);
              break;
            case 1:
              this.$toast.fail(res.Message);
              break;
            case 2:
              this.$toast.fail(res.Message);
              break;
            case 3:
              this.$toast.fail(res.Message);
              break;
            default:
              this.$toast.fail(res.Message);
              break;
          }
        }
      });
      //注册观众通知
      this.hub.on("RegisterVisitorNotice", (comment) => {
        this.$refs.liveInfo.showOpen(comment);
      });
      //点赞通知
      this.hub.on("LiveRoomLikeNotice", (comment) => {
        // console.log(comment,'点赞通知')
        this.dianzanCount = comment.LikeCount;
        if (comment.ShowAnimation) {
          this.$Bus.$emit("dzNotice");
          this.debounce();
          this.handCount += 1;
          this.actData.likeCount += 1;
        }
      });
      //收到礼物通知
      this.hub.on("GiftGivingNotice", (com) => {
        let opt = {
          nickName: com.NickName,
          Name: com.Name,
          giftName: com.Gift.Name,
          giftIcon: com.Gift.Icon,
        };
        // console.log(opt)
        this.$refs.liveGiftInfo.giftShowOpen(opt);
        // if (com.Gift.Code == "gift.big-sports-car") {
        //   this.$refs.livePaoche.paocheShow(opt);
        // }
        // opt=null;
        // this.$refs.liveInfo.showOpen(comment);
      });
      //产品推屏
      this.hub.on("PushProductNotice", (obj) => {
        if (!this.actData.exhibitorId) {
          return;
        }
        console.log(obj);
        obj.Banner = JSON.parse(obj.Banner)[0];
        this.$refs.livePro.showOpen(obj);
      });
      //取消推屏
      this.hub.on("PushProductCancelNotice", (obj) => {
        if (!this.actData.exhibitorId) {
          return;
        }
        this.$refs.livePro.showClose(obj);
      });
      // 禁止留言
      this.hub.on("ForbidCommentNotice", (msg) => { });
      // 取消留言禁止
      this.hub.on("CancelForbidCommentNotice", (msg) => { });
      // 拉黑
      this.hub.on("PullblackNotice", (msg) => {
        console.log(msg, "拉黑");
      });
      // 取消拉黑
      this.hub.on("CancelPullblackNotice", (msg) => { });
    },
    //建立连接
    getHub () {
      this.$store.commit("setRoomId", this.roomid);
      let roomId = "roomId=" + this.roomid;
      this.hub = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(`${this.api.liveApi}/hub/live?${roomId}`)
        .build();
      // 连接回调
      this.hub
        .start()
        .then((e) => {
          console.log(this.hub, "连接成功");
          this.viewerInit();
          this.getLoadMethod();
          // this.reContact(); // 超时重新连接
        })
        .then((errorMsg) => {
          console.log(errorMsg, "err");
        });
    },
    // 重新连接
    reContact () {
      const that = this;
      (function (err) {
        setTimeout(() => {
          that.getHub();
        }, 200);
      });
    },
    // 观众进入
    viewerInit () {
      if (!this.userInfo) return; // 没有用户信息
      let viewerInfo = {};
      viewerInfo.roomId = this.roomid;
      viewerInfo.userId = this.userInfo.userId;
      viewerInfo.memberId = this.userInfo.id;
      let model = {
        name: this.userInfo.name,
        nickName: this.userInfo.nickName,
        userId: this.userInfo.userId,
        avatarUrl: this.userInfo.avatarUrl,
      };
      viewerInfo.userInfo = JSON.stringify(model);
      console.log(viewerInfo, "viewinfo");
      this.hub.invoke("ViewerEntry", this.roomid, viewerInfo);
      setTimeout(() => {
        if (this.langOpt && this.langOpt.lang !== "zh") {
          this.changeLang(this.langOpt);
        } else {
          if (this.$refs.liveSubtitle) {
            this.$refs.liveSubtitle.closeSocket();
            this.$refs.liveSubtitle.reduction();
          }
        }
      }, 200);
    },
    statechange (e) {
      console.log(e);
    },
    //观众离开
    close () {
      if (this.userId && this.userInfo) {
        console.log("离开");
        this.hub.invoke("ViewerLeave", this.roomid, this.userId);
      }
    },
    ready () {
      console.log("ready");
    },
    play () {
      console.log("play");
      this.showBg = false;
    },
    ended () {
      console.log("ended");
      this.showBg = true;
    },
    liveStreamStop () {
      console.log("liveStreamStop");
      this.showBg = true;
    },
    error () {
      console.log("error");
      this.showBg = true;
    },
    // 直播

    selectHandle (e) {
      this.curIndex = e;
      if (e === 4) {
        this.showLang = true;
      }
    },
    //语言改变
    async changeLang (e) {
      let on = false;
      console.log(e, "语言e");
      this.langType = e.lang || "";
      // if(e.lang!='zh'){
      //   this.isShowSubTitle=true;
      // }
      let bool = await this.getRoomByLang(this.roomid);
      console.log("获取的数据：", bool);
      if (!bool) {
        return;
      }
      if (this.actData.enabledOtherPull) {
        this.liveUrl = this.actData.otherPullUrls;
      } else if (bool.pullUrls && !bool.pullUrls.length) {
        this.liveUrl = bool.pullUrls[2];
        return;
      }
      this.showSubtitle = bool.liveTranslateMId ? bool.liveTranslateMId : "";
      if (bool.langs) {
        bool.langs.forEach((c) => {
          if (c.lang === e.lang) {
            on = true;
            this.liveUrl = c.pullUrl[2]; // rtmp://flow2.zhanshangxiu.com/showonline/langen?auth_key=1597841251-0-0-80cec26207053550aa4e620361278f21
          }
        });
      }
      if (!on) {
        this.liveUrl = bool.pullUrls[2];
      }
      if (this.actData.enabledOtherPull) {
        this.liveUrl = this.actData.otherPullUrls;
      }
      console.log("直播地址", this.liveUrl);
      if (this.showSubtitle) {
        setTimeout(() => {
          this.$refs.liveSubtitle.init();
        }, 400);
      }
    },

    debounce () {
      if (this.timeoutflag != null) {
        clearTimeout(this.timeoutflag);
      }
      this.timeoutflag = setTimeout(() => {
        this.addhands();
      }, 2000);
    },
    addhands () {
      // 鼓掌
      console.log("执行添加鼓掌");
      let body = {
        exhibitionId: this.exhibitionId,
        activityId: this.query.actId,
        userId: this.userInfo.userId,
        nickName: this.userInfo.nickName || this.userInfo.name,
        avatarUrl: this.userInfo.avatarUrl,
        number: this.handCount,
      };
      this.addActZan(body);
      this.handCount = 0; // 添加完后清零鼓掌次数
    },
    // 底部菜单栏操作
    async sendHandle (name) {
      if (name === "home") {
        let opt = {
          url: `/home/${this.exhibitionId}`,
        };
        this.LinkFooter(opt);
      }
      if (name === "collect") {
        if (!this.userInfo) {
          this.$Myapollo.NoUserInfo(this);
          return;
        }
        if (this.isFollow) {
          // 已关注取消关注
          let body = {
            activityId: this.query.actId,
            userId: this.userInfo.userId,
          };
          this.delActLove(body);
          this.isFollow = !this.isFollow;
          this.$toast.success("Cancel");
        } else {
          // 未关注添加关注
          let body = {
            exhibitionId: this.exhibitionId,
            activityId: this.query.actId,
            userId: this.userInfo.userId,
            nickName: this.userInfo.nickName || this.userInfo.name,
            avatarUrl: this.userInfo.avatarUrl,
          };
          this.addActLove(body);
          this.isFollow = !this.isFollow;
          this.$toast.success("Followed");
        }
      }
      if (name === "Love") {
        if (!this.userInfo) {
          this.$Myapollo.NoUserInfo(this);
          return;
        }
        if (this.isFollow) {
          // 已关注取消关注
          let body = {
            activityId: this.query.actId,
            userId: this.userInfo.userId,
          };
          this.delActLove(body);
          this.isFollow = !this.isFollow;
          this.$toast.success("Cancel");
        } else {
          // 未关注添加关注
          let body = {
            exhibitionId: this.exhibitionId,
            activityId: this.query.actId,
            userId: this.userInfo.userId,
            nickName: this.userInfo.nickName || this.userInfo.name,
            avatarUrl: this.userInfo.avatarUrl,
          };
          this.addActLove(body);
          this.isFollow = !this.isFollow;
          this.$toast.success("Followed");
        }
      }
      if (name === "zan") {
        let body = {
          targetType: "activity",
          targetId: this.query.actId,
          actionType: "like",
        };
        let res = null;
        if (this.userInfo) {
          if (this.isLike) {
            // 已点赞取消点赞
            this.$toast("You already like it!");
          } else {
            // 未点赞添加点赞
            let body = {
              exhibitionId: this.exhibitionId,
              activityId: this.query.actId,
              userId: this.userInfo.userId,
              nickName: this.userInfo.nickName || this.userInfo.name,
              avatarUrl: this.userInfo.avatarUrl,
              number: 1,
            };
            await this.addActZan(body);
            this.isLike = !this.isLike;
            this.$toast.success("success");
            this.actData.likeCount += 1;
            //  if(this.typeIndex === 1){
            //    this.$refs.follow.addZan();
            //  }
            if (this.userInfo.country) {
              body.country = this.userInfo.country;
              res = await this.addViewLikeIpByCountry(body);
            }
          }
        } else {
          res = await this.addViewLikeIp(body);
        }
        if (res.result) {
          this.$toast.success("success");
          // if(this.typeIndex === 1){
          //   this.$refs.follow.addZan();
          // }
        } else {
          this.$toast.fail("Like failed");
        }
      }
      if (name === "us") {
        if (!this.userInfo) {
          this.$Myapollo.NoUserInfo(this);
          return;
        }
        if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
          let opt = null;
          this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId, opt);
        } else {
          this.$refs.order.open();
        }
      }
      if (name === "share") {
        this.share();
      }
      if (name === "close") {
        let opt = {
          url: `/activity/${this.exhibitionId}`,
        };
        this.LinkFooter(opt);
      }
    },
    //分享点击
    async share () {
      let opt = {
        title: "给您推荐一个优质活动",
        bannerTitle: this.actData.title, //公司名字
        subhead: "",
        banner: this.banner.slice(0, 3),
        type: "act",
      };
      this.$nextTick(() => {
        this.$refs["liveShare"].open(opt);
      });
      await true;
    },
    // 右侧工具栏操作
    toolTouch (type) {
      console.log(this.query.actId, "actid");
      if (type === "ting") {
        // 链接邀请函
        if (this.actData.company && this.actData.company.id) {
          // 展商活动
          this.LinkExInvitation({
            companyId: this.actData.company.id,
            exhibitorId: this.actData.exhibitorId,
            exhibitionId: this.actData.exhibitionId,
          });
        } else {
          // 主办活动
          this.$toast("该活动为主办活动");
        }
      }
      if (type === "talk") {
        console.log("交流");
      }
      if (type === "join") {
        if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
          this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
          return;
        }
        // if(this.actData.hasReg){
        //   this.$toast('您已报名')
        //   return
        // }
        this.LinkToActReg(this.roomid);
      }
      if (type === "order") {
        if (this.userInfo.inMember.userRole.toUpperCase() == "VISITOR") {
          this.$Myapollo.unverifiedDialog(this, true, this.exhibitionId);
          return;
        }
        this.LinkToActBuy(this.roomid);
      }
      if (type === "gift") {
        // 礼物

        this.showGift = true;
      }
      if (type === "hot") {
        // 上热榜
        this.$refs["hot"].open("上热榜");
      }
      if (type === "public") {
        // 发布话题
        if (!this.userInfo.phone) {
          this.$Myapollo.unverifiedDialog(this);
          return;
        }
        if (this.actData.exhibitorId) {
          // 展商活动
          this.LinkHotPub({ id: this.query.actId, talkId: false });
        } else {
          // 主办活动
          this.LinkHotPub({ id: this.exhibitionId, talkId: false });
        }
      }
      if (type === "live") {
        this.$refs["hot"].open("上直播");
      }
    },
    //礼物关闭
    giftClose () {
      console.log("礼物关闭");
      // this.curIndex=0;
      this.showLang = false;
      this.$refs.liveModule.selectHandle(0);
      $(".live_tab_swipe").animate({ scrollLeft: 0 }, 500);
    },
    // 送礼物
    sendgift (data) {
      let opt = {
        nickName: this.userInfo.nickName,
        Name: this.userInfo.name,
        giftName: data.name,
        giftIcon: data.icon,
      };
      this.$refs.liveGiftInfo.giftShowOpen(opt);
      if (data.amount == 0) {
        this.debounce();
        this.handCount += 1;
        this.actData.likeCount += 1;
      }
    },
    //轮播改变
    swiperChange (index) {
      if (this.isAutoplay == "-") {
        //如果改变的时候视频正在播放，则暂停
        this.$refs.videoPlays.swiperChange();
        this.isAutoplay = this.autoPlayVal;
      }
    },
    //视频播放
    onVideoPlay () {
      this.isAutoplay = "-";
    },
    //视频暂停
    onVideoPause (index) {
      this.isAutoplay = this.autoPlayVal;
    },
    async getActDetails () {
      this.$apollo.addSmartQuery("activity", {
        query: this.ActDetailsGql,
        variables: {
          id: this.query.actId,
        },
        fetchPolicy: "network-only", //清理缓存
        result (res) {
          if (res.data.activity) {
            this.actData = res.data.activity;
            if (!this.exhibitionConfig) { 
              this.$Myapollo.getExhibitionInfo(this, this.exhibitionId);
            }
            console.log('showRegConfirm: hasUserInfo', this.hasUserInfo);
            console.log('showRegConfirm: anonymousView', this.actData.anonymousView);
            console.log('showRegConfirm: isRegOk', this.isRegOk);
            if (this.actData && !this.actData.anonymousView) { // 有活动信息且不允许匿名观看
              if (!this.hasUserInfo) {// 没有用户信息
                this.showRegConfirm(); // 用户未登录或已登录但没手机号 且活动没有开启匿名观看 弹窗提示“请注册后观看“
              } else {
                if (!this.isRegOk) { // 有用户信息 且没有在当前展会下注册 则跳转j
                  this.showRegConfirm2(); // 用户未登录或已登录但没手机号 且活动没有开启匿名观看 弹窗提示“请注册后观看“
                }
              }
            }
            this.exhibitorId = this.actData.exhibitorId;
            console.log(this.actData, " this.exhibitorId");
            if (this.actData.banners.indexOf("[") != -1) {
              this.banner = JSON.parse(this.actData.banners);
            } else {
              this.banner = [this.actData.banners];
            }
            if (this.actData.videos) {
              this.videos = JSON.parse(this.actData.videos);
            }
            if (
              this.actData.introduction &&
              this.actData.introduction.indexOf("[") !== -1
            ) {
              this.introduction = JSON.parse(this.actData.introduction);
            } else if (this.actData.introduction) {
              let arr = [
                {
                  text: {
                    type: 1,
                    content: this.actData.introduction,
                    fontSize: "14px",
                    color: "#000",
                    position: "left",
                  },
                },
              ];
              this.introduction = arr;
            }
            this.regMsg = {
              regStartAt: this.actData.regStartAt,
              regEndAt: this.actData.regEndAt,
              regFee: this.actData.regFee,
              regMaximum: this.actData.regMaximum,
            };
            if (this.actData.liveStateIndex == 1) {
              this.isLiveTime = true;
            } else {
              this.isLiveTime = false;
            }

            this.docTitle =
              (this.actData.isExhibitionActivity
                ? this.actData.titleEn
                : this.actData.title) || "Activity";
            console.log(res.data.activity, "活动详情");
            this.getShareVal();
            this.getLiveUrl(this.roomid); // 获取房间的拉流地址
            this.checkLiveView();
            this.$store.commit("setExhibitionId", this.actData.exhibitionId);
            if (this.actData.exhibitorId) {
              this.$store.commit(
                "company/setExhibitorId",
                this.actData.exhibitorId
              );
            }
          } else {
            this.LinkToError();
          }
        }, // 错误处理
        error (error) {
          console.error(error, "error错误处理");
        },
      });
    },
    // 获取自定义分享
    async getShareVal () {
      let res = await this.getSettingShare({
        id: this.exhibitionId,
        name: "share.activity.config",
      });
      if (res) {
        let shareMsg = JSON.parse(res);
        let objTemp = {
          act: this.actData.title,
          CompanyName: this.actData.company ? this.actData.company.name : "",
          booth: this.actData.exhibitor ? this.actData.exhibitor.boothInfo : "",
        };
        let opt = {
          temp: shareMsg.content,
          objTemp: objTemp,
        };
        let optdes = {
          temp: shareMsg.des,
          objTemp: objTemp,
        };
        let msg = await this.generateShareTemplate(opt);
        let des = await this.generateShareTemplate(optdes);
        shareMsg.content = msg;
        shareMsg.des = des;
        this.shareV = shareMsg;
      }
      // 活动的分享配置
      const req = {
        title: this.shareV.content || this.actData.title,
        desc: this.shareV.des || this.actData.introductionEn || "",
        link: window.location.href,
        imgUrl:
          this.actData.banners.indexOf("[") == -1
            ? this.actData.banners
            : JSON.parse(this.actData.banners)[0],
      };
      this.shareToWechat(req);
    },
    checkForm () {
      this.$store.commit("wxShare/setFromType", 4); // 判断是否来源于活动
      let body = {
        activityId: this.query.actId,
        userId: this.userInfo.userId,
      };
      this.$store.commit("wxShare/setFromData", body);
    },
    checkLiveView () {
      if (!this.userInfo) return;
      let opt = {
        roomId: this.query.actId,
        memberId: this.userInfo.id,
        code: this.actData.liveViewPassword || "",
      };
      this.$http
        .get(
          `${this.api.api}/api/v1/liveroom/view?roomId=${opt.roomId}&memberId=${opt.memberId}&code=${opt.code}`,
          this.$store.state.header
        )
        .then((data) => {
          if (data.data) {
            this.isViewLive = data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showRegConfirm () {
      Dialog.confirm({ message: 'Please log in to watch.', confirmButtonText: 'confirm', cancelButtonText: 'cancel' })
        .then(() => {
          this.regClick();
        })
        .catch(() => {
          console.log('取消');
          this.$router.push(`/activity/${this.exhibitionId}`);
        });
    },
    showRegConfirm2 () {
      Dialog.confirm({ message: 'Please complete the information to watch.', confirmButtonText: 'confirm', cancelButtonText: 'cancel' })
        .then(() => {
          this.regClick();
        })
        .catch(() => {
          console.log('取消');
          this.$router.push(`/activity/${this.exhibitionId}`);
        });
    },
    regClick () {
      console.log('object');
      let opt = {
        originType: "exhibitor",
        originId: this.actData.exhibitorId,
        originRemark: '',
      };
      this.LinkToReg(opt)
    },
  },
  destroyed () {
    this.$store.commit("wxShare/setFromData", null);
    this.$store.commit("wxShare/setFromType", 0);
  },
  beforeDestroy () {
    if (this.$refs.liveSubtitle) {
      this.$refs.liveSubtitle.closeSocket();
    }
    if (this.hub && this.userInfo) {
      console.log("onUnload", this.hub);
      //手动关闭连接
      this.hub.invoke("ViewerLeave", this.roomid, this.userInfo.userId);
    }
  },
};
</script>

<style lang="scss" scoped>
.live {
  height: 4.23rem;
  position: relative;
  &-content {
    padding: 10px 15px;
    z-index: 2;
    position: relative;
  }
  &-layer {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("https://img.zhanshangxiu.com/showonline/file/202009/5834de2fce5d4505981eb13e80521b8b.png");
    background-size: 100%;
    &-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: inherit;
      z-index: 10;
      background: rgba(0, 0, 0, 0.4);
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 40px;
      height: 40px;
    }
  }
  .my-swipe {
    height: 100%;
  }
}

.list {
  flex-direction: column;
  padding: 15px;
  background: #fff;
  box-shadow: 0px 0.05rem 0.15rem 0px rgba(0, 0, 0, 0.1);
  &-title {
    font-weight: 600;
    font-size: 16px;
    display: flex;
    align-items: center;
    // line-height: 1.5;
    margin-bottom: 8px;
    .my-brand {
      line-height: initial;
      width: 0.88rem;
      height: 0.3rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
        linear-gradient(#000, #000);
      background-blend-mode: normal, normal;
      border-radius: 0.05rem;
      color: #fff;
      font-size: 0.18rem;
      vertical-align: middle;
      margin-right: 4px;
      margin-left: initial;
      &.dot {
        &::before {
          content: "";
          display: block;
          width: 0.12rem;
          height: 0.12rem;
          border-radius: 50%;
          background-color: #fff;
          margin-right: 0.06rem;
        }
      }
      &.s-blue {
        background-image: linear-gradient(90deg, #56ccf2 0%, #2f80ed 100%),
          linear-gradient(#000, #000);
      }
      &.s-gray {
        background-image: linear-gradient(90deg, #ffc659 0%, #ffa751 100%),
          linear-gradient(#000, #000);
      }
    }
    .dot {
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
        linear-gradient(#000, #000);
    }
    &-txt {
      display: inline-block;
      max-width: 4rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-right: 10px;
      font-size: 15px;
      color: #333;
      min-height: 0.34rem;
    }
    &-txt2 {
      font-size: 11px;
      color: #666;
      text-align: right;
      display: flex;
      align-items: center;
      background: #f3f3f3;
      border-radius: 3px;
      padding-right: 5px;
      position: absolute;
      right: 15px;
      padding: 3px 4px 3px 8px;
      img {
        // height: 24px;
        width: 0.28rem;
        display: inline-block;
        margin-right: 0.1rem;
      }
      span {
        font-size: 0.2rem;
        color: #666;
        position: relative;
        left: -5px;
      }
      // span{
      //   width: 1.2rem;
      //   height: 32px;
      //   text-align: center;
      //   display: block;
      //   background-color: #f3f3f3;
      //   img{
      //     height: 32px;
      //     display: inline-block;
      //   }
      // }
    }
  }
  &-main {
    font-size: 13px;
    color: #666;
  }
}
.top {
  // height: 7.34rem;
}
.content_wrap {
  position: relative;
}
.content2 {
  height: calc(100vh - 7.34rem);
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
}
.live_subtitle_wrap {
  position: absolute;
  pointer-events: none;
  min-height: 1.6rem;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 10;
}
#barrage {
  height: 100%;
  position: relative;
}
.tab-nav {
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid #f2f2f2;
  span {
    font-size: 0.26rem;
    position: relative;
  }
  .typeActive {
    color: #0190fe;
  }
  .typeActive::after {
    content: "";
    display: block;
    width: 0.54rem;
    height: 0.04rem;
    background-color: #0190fe;
    border-radius: 0.02rem;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -0.1rem;
    margin: auto;
  }
}
.content-bot {
  height: calc(100vh - 7.34rem);
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
}
</style>
